<template>
  <div>
    <div
      :class="$style.container"
    >
      <div
        v-if="showQueryInput"
        :class="$style.inputContainer"
      >
        <InputValidator
          :config="inputConfig"
          data-test-id="idmImportSection_query"
          :tooltip="tooltip"
          @InputValidatorModel="inputQueryChangeHandler"
        />
        <p :class="$style.supportingText">
          Customize a query supported by your service provider to control
          filtering, sorting, and searching
        </p>
      </div>
      <div :class="$style.buttonContainer">
        <FlatActionButton
          :action="initiateApplicationUserImport"
          :class="$style.usePointer"
          :disabled="!isScimActive"
          text="manual import"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { AppModel, scimConnectionTypes } from 'client/util/Constants/ApplicationConstants';
import { isValidQuery } from 'client/applications/utils/ApplicationUtils';
import { mapActions, mapState } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import { Constants as uiConstants } from '@jumpcloud/ui-components';
import DirectoryDialogsHelper from 'client/directories/DirectoryDialogsHelper';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';
import Util from 'client/util/Util';

const { ItemTypeConsts, StoreModuleMap } = Constants;
const { scimUserImport } = ItemTypeConsts;
const ScimUsersImportCollection = StoreModuleMap[scimUserImport];
const { error } = uiConstants.notificationTypes;

export default {
  name: 'ScimUsersImportSection',

  components: {
    FlatActionButton,
    InputValidator,
  },

  inject: ['$validator'],

  data() {
    return {
      countUsers: 0,
      showOptsModal: false,
      tooltip: {
        text: 'This query will only save once an import is initiated and a successful response is received.',
      },
    };
  },

  computed: {
    ...mapState(AppModel, [
      'isScimActive',
      'scimConnectionType',
      'item',
    ]),

    ...mapState(ScimUsersImportCollection, {
      importInjectionQuery: state => state.features.importInjectionQuery,
    }),

    inputConfig() {
      return {
        name: 'Parameterized query',
        label: 'Parameterized query',
        validate: 'isValidQuery',
        value: this.importInjectionQuery,
        disabled: !this.isScimActive,
      };
    },

    showQueryInput() {
      return this.scimConnectionType === scimConnectionTypes.CUSTOM;
    },
  },

  created() {
    this.setScimApplicationId({ scimAppId: this.item.id });
  },

  beforeMount() {
    isValidQuery(this.$validator);
  },

  methods: {
    ...mapActions(AppModel, ['setOAuthConfigValue']),

    ...mapActions(ScimUsersImportCollection, [
      'setImportInjectionQuery',
      'setScimApplicationId',
    ]),
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerNotification',
      'removeNotification',
    ]),

    async initiateApplicationUserImport() {
      await DirectoryDialogsHelper.showScimUsersImportModal(this.item.id);
    },

    inputQueryChangeHandler(val) {
      this.setImportInjectionQuery(val);
    },

    notifyError(message = 'Something went wrong. Please try again.') {
      const options = {
        id: Util.getUniqueId(),
        title: 'Error',
        message,
        showCloseButton: false,
        icon: error,
        type: error,
      };
      this.triggerNotification(options);
    },
  },
};
</script>

<style module>
@import '../scim/css/IdentityManagementCommon.css';

.container {
  align-items: center;
  display: flex;
}

.inputContainer {
  flex: 1 2 auto;
  margin-right: 1rem;
}

.buttonContainer {
  display: inline-block;
  flex-basis: 1 1 auto;
  padding-bottom: 20px;
}
</style>
